/**
 * @generated SignedSource<<f4611b665fe47b2cfb3582cd93ca89bc>>
 * @relayHash 869a2bd772fb159ae542d7e503a4de80
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 869a2bd772fb159ae542d7e503a4de80

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocTestCaseScenario = "MSN" | "MSN_WITH_SECOND_OPINION" | "PMN";
export type useBetterDocHealthSummaryQuery$variables = Record<PropertyKey, never>;
export type useBetterDocHealthSummaryQuery$data = {
  readonly de_betterDocHealthSummary: {
    readonly failedExchangeCountLast24Hours: number;
    readonly lastSuccessfulExchangeAt: string | null;
    readonly stuckSessions: ReadonlyArray<{
      readonly session: {
        readonly isTestCase: boolean;
        readonly partnerSessionId: string;
        readonly sessionId: number;
        readonly testCaseScenario: de_BetterDocTestCaseScenario | null;
      };
      readonly waitingSince: string;
    }>;
  };
};
export type useBetterDocHealthSummaryQuery = {
  response: useBetterDocHealthSummaryQuery$data;
  variables: useBetterDocHealthSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "de_BetterDocHealthSummary",
    "kind": "LinkedField",
    "name": "de_betterDocHealthSummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastSuccessfulExchangeAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failedExchangeCountLast24Hours",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocStuckSession",
        "kind": "LinkedField",
        "name": "stuckSessions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "waitingSince",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocSessionSummary",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partnerSessionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTestCase",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "testCaseScenario",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBetterDocHealthSummaryQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useBetterDocHealthSummaryQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "869a2bd772fb159ae542d7e503a4de80",
    "metadata": {},
    "name": "useBetterDocHealthSummaryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d3c5028c4c645bdccdf866ae7d29a90d";

export default node;
